<template>
	<div class="content">
        <OwnerBanner :supervisor="supervisor" :showExitBtn="true" />
        <ul class="nav nav-pills nav-pills-primary nav-pills-icons justify-content-center mb-2" role="tablist">
            <li v-if="checkAccess('full') || checkAccess('staging') || checkAccess('live')" class="nav-item">
                <a :class="{'nav-link': true, 'active': section === 'sites'}" data-toggle="tab" href="#sites" @click="changeSection('sites')">
                    Sites
                </a>
            </li>
            <li v-if="checkAccess('tickets')" class="nav-item">
                <a :class="{'nav-link': true, 'active': section === 'tickets'}" data-toggle="tab" href="#tickets" @click="changeSection('tickets')">
                    Support Tickets
                </a>
            </li>
            <li v-if="checkAccess('tickets')" class="nav-item">
                <a :class="{'nav-link': true, 'active': section === 'create-tickets'}" data-toggle="tab" href="#createTickets" @click="changeSection('create-tickets')">
                    Create Ticket
                </a>
            </li>
            <li v-if="checkAccess('installation')" class="nav-item">
                <a :class="{'nav-link': true, 'active': section === 'add-new-site'}" data-toggle="tab" href="#addNewSite" @click="changeSection('add-new-site')">
                    Add New Site
                </a>
            </li>
            <li v-if="checkAccess('installation') && !isNewAccount" class="nav-item">
                <a :class="{'nav-link': true, 'active': section === 'migration-request'}" data-toggle="tab" href="#migrationRequest" @click="changeSection('migration-request')">
                    Migration Request
                </a>
            </li>
        </ul>
        <div class="tab-content tab-space tab-subcategories">
            <div v-if="checkAccess('full') || checkAccess('staging') || checkAccess('live')" :class="{'tab-pane': true, 'active': section === 'sites'}" id="sites">
                <div class="row animated fadeIn">
                    <div class="col-12">
                        <div class="card" v-if="asyncDone === false">
                            <div class="loader"></div>
                            <h4 class="text-center">{{asyncText}}</h4>
                        </div>
                    </div>
                    <div class="col-12 view-details-wrapper" v-if="asyncDone && exactDomain">
                        <div class="card">
                            <div class="card-header mt-4">
                                <h4 class="card-title d-inline-block mr-4 ml-4 view-details-title">Site:</h4>
                                <select class="d-inline-block form-control-sm" data-live-search="true" data-width="fit"
                                        v-model="domainIndex">
                                    <option v-for="(domain, index) in domainList" :key="index" :value="index">{{ domain }}
                                    </option>
                                </select>
                            </div>
                            <div class="card-body pl-5 pr-5" v-if="exactDomain.status === 'active'">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="d-inline-block mr-2" :class="{ 'square-live' : envType === 'live', 'square-staging' : envType === 'staging' }"></div>
                                        <div class="d-inline-block env-name-top">{{ envType }} Environment</div>
                                        <p>Hosting details of the {{ envType }} environment</p>
                                    </div>
                                    <div class="col-6">
                                        <div class="float-right" v-if="$route.query.tab !== 'dns'">
                                            <div class="form-group">
                                                <template v-if="isShowEnvDropDown">
                                                    <label for="changeEnv" class="mr-3">Change Environment</label>
                                                    <select class="form-control-sm" id="changeEnv" v-model="envType">
                                                        <option value="live">Live Environment</option>
                                                        <option value="staging" :disabled="exactDomain.staging && exactDomain.staging.enabled === false">Staging Environment</option>
                                                    </select>
                                                </template>
                                                <button type="button" @click="createStaging(exactDomain.domain)" style="margin-left: 10px" v-if="exactDomain.staging && exactDomain.staging.enabled === false && checkAccess('full')" :disabled="stagingRequested" class="btn btn-outline-primary btn-round btn-sm">
                                                    <div class="loader small_loader" v-if="stagingRequested"></div>
                                                    <span v-else>
												        Create Staging
											        </span>
                                                </button>
                                                <button type="button" @click="pushToStaging(exactDomain.domain)" style="margin-left: 10px" v-if="exactDomain.staging && exactDomain.staging.enabled === true && envType === 'live' && checkAccess('full')" :disabled="stagingRequested" class="btn btn-outline-primary btn-round btn-sm">
                                                    <div class="loader small_loader" v-if="stagingRequested"></div>
                                                    <span v-else>
												        Push To Staging
											        </span>
                                                </button>
                                                <button type="button" @click="pushToLive()" style="margin-left: 10px" v-if="envType === 'staging' && exactDomain.staging && exactDomain.staging.enabled === true && checkAccess('full')" :disabled="pushToLiveRequested" class="btn btn-outline-primary btn-round btn-sm">
                                                    <div class="loader small_loader" v-if="pushToLiveRequested"></div>
                                                    <span v-else>
												Push To Live
											</span>
                                                </button>

                                              <button type="button" v-if="checkAccess('full') && exactDomain.staging && exactDomain.staging.enabled === true && envType === 'staging'"  data-toggle="tooltip" data-placement="top" title="Remove Staging" @click="removeStagingDomain(exactDomain)" style="margin-left: 10px" :disabled="removeStagingRequested" class="btn btn-outline-danger btn-round btn-sm">
                                                  <div class="loader small_loader" v-if="removeStagingRequested"></div>
                                                  <span v-else>
                                                      Remove Staging
                                                  </span>
                                              </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="(envType === 'staging' && exactDomain.staging.enabled === true) || envType === 'live'">
                                    <div class="col-sm-12 col-md-2 mb-2">
                                        <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist"
                                             aria-orientation="vertical">
                                            <a :class="{'nav-link': true, 'active': currentTab === 'info'}"
                                               @click="changeTab('info')" id="v-pills-info-tab" data-toggle="pill"
                                               href="#v-pills-info" role="tab" aria-controls="v-pills-info"
                                               aria-selected="true">Info</a>
                                            <a :class="{'nav-link': true}"
                                               @click="changeTab('wordpress')"  id="v-pills-wordpress-tab"
                                               href="javascript:void(0)"  >WordPress</a>
                                            <a v-if="openWordPressTabs && !(adminDtls && adminDtls.userType === 'manager')"
                                               :class="{'nav-link': true, 'active':  currentTab === 'admin_users','ml-3':openWordPressTabs}"
                                               @click="changeTab('admin_users')"  id="v-pills-admin-users-tab" data-toggle="pill"
                                               href="#v-pills-admin-users" role="tab" aria-controls="v-pills-users" aria-selected="false">Admin Users</a>
                                            <a v-if="openWordPressTabs"
                                               :class="{'nav-link': true, 'active':  currentTab === 'plugins','ml-3':openWordPressTabs}"
                                               @click="changeTab('plugins')"  id="v-pills-plugins-tab" data-toggle="pill"
                                               href="#v-pills-plugins" role="tab" aria-controls="v-pills-plugins" aria-selected="false">Plugins</a>
                                            <a :class="{'nav-link': true, 'active': currentTab === 'backups'}"
                                               @click="changeTab('backups')" id="v-pills-backup-tab" data-toggle="pill"
                                               href="#v-pills-backup" role="tab" aria-controls="v-pills-backup"
                                               aria-selected="false">Backups</a>
                                            <a :class="{'nav-link': true, 'active': currentTab === 'domains'}"
                                               @click="changeTab('domains')"  id="v-pills-info-domains" data-toggle="pill"
                                               href="#v-pills-domains" role="tab" aria-controls="v-pills-domains" aria-selected="true">Domains</a>
                                            <a v-if="hasCloudflareSettings()"
                                               :class="{'nav-link': true, 'active': currentTab === 'traffic'}"
                                               @click="changeTab('traffic')" id="v-pills-traffic-tab" data-toggle="pill"
                                               href="#v-pills-traffic" role="tab" aria-controls="v-pills-traffic"
                                               aria-selected="false">Traffic</a>
                                            <a v-if="checkAccess('full')" :class="{'nav-link': true, 'active': currentTab === 'redirects'}"
                                               @click="changeTab('redirects')" id="v-pills-redirects-tab" data-toggle="pill"
                                               href="#v-pills-redirects" role="tab" aria-controls="v-pills-redirects"
                                               aria-selected="false">Redirects</a>
                                            <a v-if="hasCloudflareSettings() && checkAccess('full')"
                                               :class="{'nav-link': true, 'active': currentTab === 'dns'}"
                                               @click="changeTab('dns')" id="v-pills-dns-tab" data-toggle="pill"
                                               href="#v-pills-dns" role="tab" aria-controls="v-pills-dns" aria-selected="false">DNS
                                                records</a>
                                            <a :class="{'nav-link': true, 'active': currentTab === 'cache'}"
                                               @click="changeTab('cache')" id="v-pills-cache-tab" data-toggle="pill"
                                               href="#v-pills-cache" role="tab" aria-controls="v-pills-cache"
                                               aria-selected="false">Clear cache</a>
                                              <a :class="{'nav-link': true}"  id="v-pills-usage-tab"  href="javascript:void(0)"  >Security</a>
                                              <a :class="{'nav-link': true, 'active': currentTab === 'admin-lock', 'ml-3':true}" @click="changeTab('admin-lock')" id="v-pills-admin-lock-tab" data-toggle="pill" href="#v-pills-admin-lock" role="tab" aria-controls="v-pills-admin-lock" aria-selected="false">Login Lock</a>
                                              <a :class="{'nav-link': true, 'active': currentTab === 'block-ips', 'ml-3':true}" @click="changeTab('block-ips')" id="v-pills-block-ips-tab" data-toggle="pill" href="#v-pills-block-ips" role="tab" aria-controls="v-pills-block-ips" aria-selected="false">Block IPs</a>
                                            <a v-if="hasCloudflareSettings()"
                                               :class="{'nav-link': true, 'active': currentTab === 'ssl'}"
                                               @click="changeTab('ssl')" id="v-pills-ssl-tab" data-toggle="pill"
                                               href="#v-pills-ssl" role="tab" aria-controls="v-pills-ssl" aria-selected="false">SSL</a>
                                            <a :class="{'nav-link': true}"  id="v-pills-util-tab"  href="javascript:void(0)"  >Utilities</a>
                                            <a :class="{'nav-link': true, 'active': currentTab === 'tools', 'ml-3':true}"
                                               @click="changeTab('tools')" id="v-pills-tools-tab" data-toggle="pill" href="#v-pills-tools"
                                               role="tab" aria-controls="v-pills-tools" aria-selected="false">Tools</a>
                                            <a :class="{'nav-link': true, 'active': currentTab === 'logs', 'ml-3':true}"
                                               @click="changeTab('logs')" id="v-pills-logs-tab" data-toggle="pill" href="#v-pills-logs"
                                               role="tab" aria-controls="v-pills-logs" aria-selected="false">PHP Error Logs</a>

                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-10 mb-10">
                                        <div class="tab-content mt-3" id="v-pills-tabContent">
                                            <div :class="{'tab-pane fade': true, 'show active': currentTab === 'info'}"
                                                 id="v-pills-info" role="tabpanel" aria-labelledby="v-pills-info-tab">
                                                <transition enter-active-class="animated fadeIn faster"
                                                            leave-active-class="animated fadeOut faster" mode="out-in">
                                                    <LiveDetails :account="exactDomain" envType="live"
                                                                 v-if="envType === 'live'" :collaboration="true" :supervisor="supervisor"/>
                                                    <StagingDetails v-if="exactDomain && envType === 'staging'"
                                                                    :account="exactDomain.staging" envType="staging" :collaboration="true" :supervisor="supervisor"/>
                                                </transition>
                                            </div>
                                            <div :class="{'tab-pane fade': true, 'show active': currentTab === 'admin_users'}" id="v-pills-admin-users" role="tabpanel" aria-labelledby="v-pills-admin-users-tab">
                                                <AdminUsers :account="exactDomain"  :envType="envType" :fromCollaborator="true" :supervisor="supervisor"/>
                                            </div>
                                            <div :class="{'tab-pane fade': true, 'show active': currentTab === 'plugins'}" id="v-pills-plugins" role="tabpanel" aria-labelledby="v-pills-plugins-tab">
                                                <Plugins :account="exactDomain"  :envType="envType" />
                                            </div>
                                            <div :class="{'tab-pane fade': true, 'show active': currentTab === 'backups'}"
                                                 id="v-pills-backup" role="tabpanel" aria-labelledby="v-pills-backup-tab">
                                                <BackupList :fromCollaborator="true" :supervisor="supervisor" :account="exactDomain" :envType="envType"></BackupList>
                                            </div>
                                            <div :class="{'tab-pane fade': true, 'show active': currentTab === 'domains'}"
                                                 id="v-pills-domains" role="tabpanel" aria-labelledby="v-pills-backup-tab">
                                                <DomainAliases :account="exactDomain" :envType="envType" :fromCollaborator="true" :supervisor="supervisor"  />
                                            </div>
                                            <div v-if="hasCloudflareSettings()"
                                                 :class="{'tab-pane fade': true, 'show active': currentTab === 'traffic'}"
                                                 id="v-pills-traffic" role="tabpanel" aria-labelledby="v-pills-traffic-tab">
                                                <TrafficList :account="exactDomain"></TrafficList>
                                            </div>
                                            <div v-if="hasCloudflareSettings() && checkAccess('full')"
                                                 :class="{'tab-pane fade': true, 'show active': currentTab === 'dns'}"
                                                 id="v-pills-dns" role="tabpanel" aria-labelledby="v-pills-dns-tab">
                                                <DNS :account="exactDomain"></DNS>
                                            </div>
                                            <div v-if="checkAccess('full')" :class="{'tab-pane fade': true, 'show active': currentTab === 'redirects'}"
                                                 id="v-pills-redirects" role="tabpanel" aria-labelledby="v-pills-redirects-tab">
                                                <RedirectList :account="exactDomain" :envType="envType"></RedirectList>
                                            </div>
                                            <div :class="{'tab-pane fade': true, 'show active': currentTab === 'cache'}"
                                                 id="v-pills-cache" role="tabpanel" aria-labelledby="v-pills-cache-tab">
                                                <ClearCache :account="exactDomain"></ClearCache>
                                            </div>
                                            <div v-if="hasCloudflareSettings()"
                                                 :class="{'tab-pane fade': true, 'show active': currentTab === 'ssl'}"
                                                 id="v-pills-ssl" role="tabpanel" aria-labelledby="v-pills-ssl-tab">
                                                <SSL :account="exactDomain"></SSL>
                                            </div>
                                            <div :class="{'tab-pane fade': true, 'show active': currentTab === 'tools'}"
                                                 id="v-pills-tools" role="tabpanel" aria-labelledby="v-pills-tools-tab">
                                                <Utilities :account="exactDomain" :envType="envType" />
                                            </div>
                                            <div :class="{'tab-pane fade': true, 'show active': currentTab === 'logs'}"
                                                 id="v-pills-logs" role="tabpanel" aria-labelledby="v-pills-logs-tab">
                                                <ErrorLogList :account="exactDomain" :isCollaborator="true" :envType="envType"  />
                                            </div>
                                            <div :class="{'tab-pane fade': true, 'show active': currentTab === 'admin-lock'}" id="v-pills-admin-lock" role="tabpanel" aria-labelledby="v-pills-admin-lock-tab">
                                              <admin-lock :account="exactDomain" :envType="envType" :fromCollaborator="true" :supervisor="supervisor" />
                                            </div>
                                            <div :class="{'tab-pane fade': true, 'show active': currentTab === 'block-ips'}" id="v-pills-block-ips" role="tabpanel" aria-labelledby="v-pills-block-ips-tab">
                                              <block-ips :account="exactDomain" :fromCollaborator="true" :supervisor="supervisor" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-else-if="envType === 'staging' && !exactDomain.staging.enabled">
                                    <div class="col-md-12">
                                        <b class="pull-right text-danger">
                                            Staging site is not exist! Please request for full access or ask owner to create the staging site.
                                        </b>
                                    </div>
                                </div>
                                <div class="row" v-else-if="envType === ''">
                                    <div class="col-md-12">
                                        <b class="pull-right text-danger">
                                            Please select environment
                                        </b>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body pl-5 pr-5" v-else>
                                <h3 class="text-center text-danger">
                                    BigScoots team is currently working on {{ exactDomain.domain }}!
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="checkAccess('tickets')" :class="{'tab-pane': true, 'active': section === 'tickets'}" id="tickets">
                <div class="row animated fadeIn">
                    <div class="col-12 view-details-wrapper">
                        <div class="card">
                            <div class="card-header mt-4">
                                <h4 class="card-title d-inline-block mr-4 ml-4 view-details-title">Ticket Archive:</h4>
                            </div>
                            <div class="card-body pl-5 pr-5">
                                <TicketsArchive ref="ticketArchiveCollaborator" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="checkAccess('tickets')" :class="{'tab-pane': true, 'active': section === 'create-tickets'}" id="createTickets">
                <div class="row animated fadeIn">
                    <div class="col-12 view-details-wrapper">
                        <div class="card">
                            <div class="card-header mt-4">
                                <h4 class="card-title d-inline-block mr-4 ml-4 view-details-title">Create New Ticket:</h4>
                            </div>
                            <div class="card-body pl-5 pr-5">
                                <OpenNewTicket :supervisor="supervisor" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="checkAccess('installation')" :class="{'tab-pane': true, 'active': section === 'add-new-site'}" id="addNewSite">
                <div class="row animated fadeIn">
                    <div class="col-12 view-details-wrapper">
                        <AddNewSite :isCollaboration="true" :supervisor="supervisor" @changeSection="changeSection" />
                    </div>
                </div>
            </div>
            <div v-if="checkAccess('installation') && !isNewAccount" :class="{'tab-pane': true, 'active': section === 'migration-request'}" id="migrationRequest">
                <NewMigration :pIndex='0' :userUID="$route.params.userId" :supervisor="supervisor" />
            </div>
        </div>

	</div>
</template>

<script>
	import {functions, db} from '@/firebase/init';
	import AES from 'crypto-js/aes'
	import CryptoJSCore from 'crypto-js/core'
	import refreshToken from "../../../../../mixins/refreshTokenMixin";
	import swal from 'sweetalert2';
	import moment from 'moment'
    import _ from 'lodash';

	export default {
		name: "viewDetailsPage",
		mixins: [refreshToken],
		data() {
			return {
			    isShowEnvDropDown: false,
                section: 'sites',
				domainIndex: '',
				envType: '',
                index: 'U2FsdGVkX1+za+tbzNt3uFtih8MedK95spJnwkKJzz8=',
                supervisor: {},
                currentTab: 'info',
                openWordPressTabs:false,
                adminDtls: JSON.parse(localStorage.getItem('adminDtls')),
        removeStagingRequested: false
			}
		},
		components: {
            ErrorLogList: () =>
                import(/* webpackChunkName: "siteList" */ "../../../../../components/User/Sites/Logs/ErrorLogList.vue"),
            OwnerBanner: () =>
                import(/* webpackChunkName: "siteList" */ "../../../../../components/Helps/OwnerInformationBanner.vue"),
            TicketsArchive: () =>
                import(/* webpackChunkName: "siteList" */ "../../../../../components/User/Collaborator/TicketsArchiveCollaborator.vue"),
            OpenNewTicket: () =>
                import(/* webpackChunkName: "siteList" */ "../../../../../components/User/Collaborator/OpenNewTicket.vue"),
            AddNewSite: () =>
                import(/* webpackChunkName: "siteList" */ "../../../../../components/User/Sites/AddSites/AddNewSite.vue"),
            NewMigration: () =>
                import(/* webpackChunkName: "siteList" */ "../../../../../components/User/Collaborator/NewMigration.vue"),
			Alert: () => import(/* webpackChunkName: "alert" */ "../../../../../components/Alerts.vue"),
			LiveDetails: () => import(/* webpackChunkName: "liveHostingDetails" */ "../../../../../components/User/Sites/ViewHostingDetails/LiveHostingDetails.vue"),
			StagingDetails: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../../components/User/Sites/ViewHostingDetails/StagingDetails.vue"),
			BackupList: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../../components/User/Backup/BackupList.vue"),
			RedirectList: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../../components/User/Redirect/RedirectList.vue"),
			TrafficList: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../../components/User/Traffic/TrafficList.vue"),
			DNS: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../../components/User/Dns/DnsList.vue"),
			ClearCache: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../../components/User/Sites/Cache/Index.vue"),
			SSL: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../../components/User/Sites/SSL/Index.vue"),
            AdminUsers: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../../components/User/AdminUsers/AdminUsers"),
            Plugins: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../../components/User/AdminUsers/Plugins"),
            Utilities: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../../components/User/Utilities/Utilities.vue"),
            DomainAliases: () => import(/* webpackChunkName: "stageHostingDetails" */ "../../../../../components/User/DomainAliases/Domains.vue"),
      AdminLock: () => import(/* webpackChunkName: "siteList" */ "../../../../../components/User/Sites/Security/AdminLock"),
      BlockIps: () => import(/* webpackChunkName: "siteList" */ "../../../../../components/User/Sites/Security/BlockIps")
		},
		computed: {
			aesSecret() {
				return this.$store.getters["crypto/aesSecret"];
			},
			asyncDone() {
				return this.$store.getters["async/state"];
			},
            asyncText() {
                return this.$store.getters["async/text"];
            },
			alertType() {
				return this.$store.getters["alert/type"];
			},
			alertMessage() {
				return this.$store.getters["alert/message"];
			},
			alertShow() {
				return this.$store.getters["alert/show"];
			},
			accOrdered() {
				return this.$store.getters["hosting/accountsOrdered"]
			},
            accountsAssigned() {
                return this.$store.getters["hosting/accounts"]
            },
            isNewAccount () {
                const hostingDetail = this.$store.getters["hosting/accounts"];
                return (hostingDetail && hostingDetail[0] && hostingDetail[0].primary.domain === '');
            },
			domainList() {
				const accounts = this.accOrdered;
				const domainList = [];
				accounts.forEach(acc => {
                    if(this.supervisor.allowedDomains && this.supervisor.allowedDomains.includes(acc.domain)){
                        domainList.push(acc.domain)
                    }
				});

				return domainList
			},
			exactDomain() {
				const accounts = this.accOrdered;
				try {
					const exactAcc = accounts[this.domainIndex];
					if (exactAcc !== void 0 && exactAcc.phpMyAdmin.url) {
						exactAcc.phpMyAdmin.url = `https://${exactAcc.phpMyAdmin.popupUsername}:${exactAcc.phpMyAdmin.popupPassword}@${exactAcc.phpMyAdmin.url.replace('https://', '')}`;
					}
					return exactAcc
				} catch (e) {
					console.log(e.message);
				}
			},
			user() {
				return this.$store.getters.user;
			},
            UID(){
                return this.$store.getters.getUID;
            },
            stagingRequested() {
                return this.$store.getters.stagingRequested;
            },
            pushToLiveRequested() {
                return this.$store.getters.pushToLiveRequested;
            },
			userToken() {
				return this.$store.getters.getUserToken;
			},
		},
		methods: {
		    checkAccess (accessLevel) {
		        if(this.supervisor.accessLevels === undefined){
              return true
              } else if(this.supervisor.accessLevels.includes('full')) {
              return true;
              } else if (this.supervisor.accessLevels.includes(accessLevel)) {
              return true;
              }
		        return false;
            },
      openFirstTab () {
        if (this.supervisor.accessLevels.includes('full') || this.supervisor.accessLevels.includes('staging') || this.supervisor.accessLevels.includes('live')) {
          this.section = 'sites';
        } else if (this.supervisor.accessLevels.includes('tickets')) {
          this.section = 'tickets';
        } else if (this.supervisor.accessLevels.includes('installation')) {
          this.section = 'add-new-site';
        } else {
          this.section = 'sites';
        }
        if (this.section === 'tickets') {
          this.$refs.ticketArchiveCollaborator.fetchTickets(0);
        }
      },
			accIndex(index) {
				if (typeof index === 'undefined') {
					this.domainIndex = ''
				} else {
					const bytes = AES.decrypt(this.index, this.aesSecret)
					this.domainIndex = parseInt(bytes.toString(CryptoJSCore.enc.Utf8))

				}
			},
			changeTab(tab) {
                if(tab ==='wordpress'){
                    if(this.$route.query.tab !=='admin_users' && this.$route.query.tab !=='plugins'){
                        this.openWordPressTabs = !this.openWordPressTabs;
                    }else{
                        this.openWordPressTabs = true;
                    }
                }else{
                    this.currentTab = tab;
                }

			},
			hasCloudflareSettings() {
				return !(this.exactDomain === undefined || this.exactDomain.cloudflare === undefined ||
					!this.exactDomain.cloudflare.zone_id ||
					this.exactDomain.cloudflare.zone_id === undefined ||
					this.exactDomain.cloudflare.zone_id == 'NA' ||
					this.exactDomain.cloudflare.zone_id == '');
			},
            pushToLive() {
                const self = this;
                let buttonHtml = '<div>' +
                    '<div>Please be aware, your live site will be completely overwritten with your staging site. If you have made any updates to your live site since creating your staging site, these updates will be lost. Please consider creating a backup of your live site prior to pushing your staging to live.</div>' +
                    '<br/>' +
                    '<ul class="list-inline">' +
                    '<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Proceed and Create Backup</button></li>' +
                    '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Proceed without Creating Backup</button></li>' +
                    '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Do Not Proceed</button></li>' +
                    '</ul></div>'
                swal({
                    title: "Would you like to proceed?",
                    html: buttonHtml,
                    type: 'question',
                    showCancelButton: false,
                    showConfirmButton: false,
                    onOpen: function () {
                        console.log('On Open');
                        /* eslint-disable */
                        $('.sw_butt1').on('click',function () {
                            console.log('migrate');
                            self.proceedWithPushToLive(true);
                            swal.close();
                        });
                        $('.sw_butt2').on('click',function () {
                            console.log('no-migrate');
                            self.proceedWithPushToLive(false);
                            swal.close();
                        });
                        $('.sw_butt3').on('click',function () {
                            console.log('close');
                            swal.close();
                        });
                        /* eslint-enable */
                    }
                });
            },
            async proceedWithPushToLive (createBackup) {
                this.$store.commit('updatePushToLiveRequested', true);
                const liveDomain = this.accOrdered[this.domainIndex].domain;
                const stagingDomain = this.accOrdered[this.domainIndex].staging.domain;
                const serverIP = this.accOrdered[this.domainIndex].serverIP;
                let date = moment().tz('America/Chicago').format('YYYY-MM-DD HH:mm:ss');
                let folderName = date.replace(/:/g, '_').replace(' ', 'T');
                this.$store.commit('updateBackupActions', {
                    value: date,
                    type: 'restore',
                    input: true
                });
                await this.$http.post('/clone/queue', {
                    ip: serverIP,
                    source: stagingDomain,
                    destination: liveDomain,
                    grant_type: "token",
                    token: this.userToken,
                    firstName: this.supervisor.supervisorName,
                    lastName: this.supervisor.supervisorName,
                    UID: this.supervisor.supervisorId,
                    createBackup: (createBackup) ? 'true' : 'false',
                    backupName: 'manual-' + folderName,
                    backupDate: date,
                    collaborator: '1',
                    collaboratorUID: this.UID
                }).then(() => {
                    this.$notify({
                        group: 'foo',
                        title: 'Request Received',
                        duration: 3000,
                        text: 'We will notify you once we are done with the request',
                        type: 'info'
                    });
                });
            },
            pushToStaging(domain) {
                swal({
                    title: "Overwrite Current Staging?",
                    text: 'By pushing to staging, all current data for your Staging site will be overwritten by your live site. Would you like to proceed?',
                    type: "question",
                    confirmButtonText: "Yes Proceed",
                    confirmButtonColor: "#6ACF98",
                    showCancelButton: true,
                    cancelButtonText: "No Thanks",
                    cancelButtonColor: "#EE8057"
                }).then( result => {
                    if(result.value){
                        console.log('Push To Staging For Domain: ' + domain);
                        this.createStaging(domain);
                    }
                });
            },
            async createStaging(domain) {
                this.$store.commit('updateStagingRequested', true);
                let finalAccount = null;
                const accountDetails = this.$store.getters['hosting/accounts'];
                let hostingAccountIndex = 0;
                let adOnAccountIndex = 0;
                let isAdOnAccount = false;
                let isAbortSearching = false;
                for(const account of accountDetails){
                    if(account.primary.domain === domain){
                        finalAccount = account.primary;
                        break;
                    }
                    for(const adon of account.addon){
                        if(adon.domain === domain){
                            finalAccount = adon;
                            isAdOnAccount = true;
                            isAbortSearching = true;
                            break;
                        }
                        adOnAccountIndex++;
                    }
                    if(isAbortSearching){
                        break;
                    }
                    hostingAccountIndex++;
                }
                console.log(finalAccount);
                console.log(domain);
                this.$http.post('/staging-request/queue', {
                    ip: finalAccount.serverIP,
                    source: domain,
                    destination: domain.replace(/\./g, "") + '.bigscoots-staging.com',
                    grant_type: "token",
                    token: this.userToken,
                    isAdOnAccount: (isAdOnAccount) ? '1' : '0',
                    hostingAccountIndex: hostingAccountIndex,
                    adOnAccountIndex: adOnAccountIndex,
                    firstName: this.supervisor.supervisorName,
                    lastName: this.supervisor.supervisorName,
                    UID: this.supervisor.supervisorId,
                    collaborator: '1',
                    collaboratorUID: this.UID
                }).then(async resp => {
                  console.log(resp.data);
                  if (resp.data.alreadyPaused) {
                    let text = resp.data.msg
                    this.$notify({
                      group: 'foo',
                      type: 'info',
                      title: 'Staging Request',
                      duration: -5000,
                      text
                    });
                    this.$store.commit('updateStagingRequested', false);
                  } else {
                    this.$notify({
                      group: 'foo',
                      type: 'info',
                      title: 'Staging Request',
                      duration: 5000,
                      text: 'Your staging request has been submitted, please stand by for it to complete!'
                    });
                  }
                    // const sound = new Audio('/eventually.mp3');
                    // sound.play();
                }).catch((err) => {
                    //generate ticket here...
                    this.createTicketIfFailed(domain);
                    this.addLog({
                        name: this.user.firstName + " " + this.user.lastName,
                        message: "Error In Staging Request for domain: "+domain+". Message: " + err.response.data.message,
                        level: "danger"
                    });
                });
            },
            createTicketIfFailed(domain){
                const errorAlert = functions.httpsCallable("stagingErrorAlert");
                errorAlert({
                    clientID: this.clientID,
                    domain: domain
                }).then(response => {
                    this.$store.dispatch("async/stateUpdate", { state: true, text: '' })
                    if(response.data.success) {
                        swal({
                            title: "Staging Failed!",
                            text: response.data.message,
                            type: "warning",
                            confirmButtonText: "OK",
                            confirmButtonColor: "#EE8057"
                        })
                    } else {
                        swal({
                            title: "Something went wrong!",
                            text: response.data.message,
                            type: "error",
                            confirmButtonText: "Try Again!",
                            confirmButtonColor: "#EE8057"
                        })
                    }
                })
            },
            changeSection(section) {
                if(section === 'tickets'){
                    this.$refs.ticketArchiveCollaborator.fetchTickets(0);
                }
                this.section = section;
            },
      async removeStagingDomain (account) {
        let staging = account.staging;
        console.log(staging);
        // First confirm the user if he truly wants to delete this domain
        const resp = await swal({
          title: "Are you sure?",
          text: `Please confirm that you would like to remove  ${staging.domain} domain permanently.`,
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        })
        if (resp.value) {
          try {
            this.removeStagingRequested = true;
            const res = await this.$http.post('staging-request/remove', {
              domain: staging.domain,
              ip: staging.ftp.host,
              isCollaborator: true,
              grant_type: "token",
              firstName: this.supervisor.supervisorName,
              lastName: this.supervisor.supervisorName,
              UID: this.supervisor.supervisorId,
              collaborator: true,
              collaboratorUID: this.UID
            })
            this.$notify({
              group: 'foo',
              title: 'Domain Removal',
              duration: 3000,
              text: res.data.msg,
              type:  'info'
            });
            this.envType = 'live';
          } catch (e) {
            swal({
              title: "Something went wrong!",
              text: 'Please contact support',
              type: "error",
            });
          }
          this.removeStagingRequested = false;
        }
      }
		},
        async created () {
			/* eslint-disable */
			$(document).ready(function () {
				$('.selectpicker').selectpicker();
			});
			/* eslint-enable */
            const {dispatch} = this.$store;
            const {params} = this.$route;

            try {
                await dispatch("async/stateUpdate", { state: false, text: 'Fetching Supervisor Details...' }, { root: true });
                console.log('Init collob again....');
                dispatch("hosting/clearAccounts");
                await dispatch("setRequestUserId", params.userId);
                this.accIndex(this.index);
                await db.collection('users').doc(this.user.uid).get().then(doc => {
                    const userDataSuperVisors = doc.data()['supervisors'];
                    for(let supervisor of userDataSuperVisors){
                        if(supervisor.supervisorId === params.userId){
                            this.supervisor = supervisor;
                            break;
                        }
                    }

                });
                if(_.isEmpty(this.supervisor)){
                    await dispatch("hosting/clearAccounts");
                    this.$router.push({ name: 'userDashboard' });
                    return;
                }
                this.envType = (this.checkAccess('full')) ? 'live' : (this.checkAccess('live')) ? 'live' :  (this.checkAccess('staging')) ? 'staging' : '';
                this.isShowEnvDropDown = this.checkAccess('full') || (this.checkAccess('staging') && this.checkAccess('live'));
                await dispatch("async/stateUpdate", { state: true, text: '' }, { root: true });
                await dispatch("async/stateUpdate", { state: false, text: 'Fetching Account Details' }, { root: true });
                if (this.accOrdered.length === 0) {
                    console.log(this.supervisor.allowedDomains);
                    await dispatch("hosting/fetchAccounts", {UID: params.userId, allowedDomains: this.supervisor.allowedDomains})
                }
                await dispatch("async/stateUpdate", { state: false, text: 'Fetching Client Details...' }, { root: true });
                const client = await db.collection("users").doc(params.userId).get();
                if(client.exists){
                    await dispatch("setRequestCustomerID", client.data().customerID);
                }
                this.openFirstTab();
                this.$store.commit('hosting/updateIsWatchSupervisorAccountFlag', true);
                await dispatch("async/stateUpdate", { state: true, text: '' }, { root: true });
                if(this.$route.query.to_migrate) {
                    this.changeSection('migration-request');
                }
            }catch (e) {
                console.error(e.message);
            }
		},
		async mounted () {

		},
		updated() {
			/* eslint-disable */
			$(document).ready(function () {
				$('.selectpicker').selectpicker();
			});
			/* eslint-enable */
		},
		destroyed() {
			console.log('Collab Site Details Destroyed....');
			const {dispatch} = this.$store;
			dispatch("setRequestUserId", this.user.uid);
			dispatch("setRequestCustomerID", this.user.customerID);
			dispatch("hosting/clearAccounts");
			dispatch('updateUserDetails', {...this.user, idToken: null});
			dispatch("hosting/fetchAccounts", {UID: this.user.uid});
            dispatch("migration/countUpdateDB");
			localStorage.setItem('userDtls', JSON.stringify({...this.user, idToken: null}));
			this.$store.commit('hosting/updateIsWatchSupervisorAccountFlag', false);
			this.refreshToken();
		}
	}
</script>

<style lang="scss">
	.square-live {
		width: 15px;
		height: 15px;
		background-color: #2DCA87;
	}

	.square-staging {
		width: 15px;
		height: 15px;
		background-color: #8E45AB;
	}

	.env-name-top {
		font-size: 18px;
		text-transform: uppercase;
	}

	.view-details-wrapper {
		.bootstrap-select {
			vertical-align: super;

			.dropdown-toggle {
				border: none;

				&:hover {
					border: none !important;
				}

				.filter-option {
					.filter-option-inner {
						.filter-option-inner-inner {
							font-size: 14px;
						}
					}
				}
			}
		}
	}

	.heading-text {
		font-weight: bold;
		font-size: 16px;
	}

	.col-mb {
		color: #303952;
	}

	#changeEnv option:disabled {
		background: red;
		color: #fff;
	}

	.view-details-title {
		position: relative;
		top: 4px;
	}
</style>
